import type { ReactNode } from "react";

/** null / undefined / 空文字 / false は「未設定」。 */
export function isUnset(v: ReactNode): boolean {
  return v == null || v === "" || v === false;
}
